import { CSSObject } from "@emotion/react";
import {
  typographyStyles,
  CheckboxStyleOverrides,
  AngelouCSS,
} from "@newsela/angelou";

const { textSObj, textMObj } = typographyStyles;

export const rootCss: CSSObject = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const listContainerCss: CSSObject = {
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

export const listItemCss: CSSObject = {
  listStyle: "none",

  "> div": {
    display: "flex",
    alignItems: "center",
  },
};

export const checkboxCss: CheckboxStyleOverrides<AngelouCSS> = {
  root: {
    padding: 0,
  },

  labelText: {
    ...textMObj,
    marginTop: "-3px",
  },
};

export const standardDescriptionCss: CSSObject = {
  ...textSObj,
  margin: 0,
  marginTop: "-2px",
  paddingLeft: "35px",
};
